import React from 'react';
import { Button } from 'antd';
import { MenuFoldOutlined } from '@ant-design/icons';
import labels from '../../../constants/labels.json';
import styles from './FixedMenuButton.module.css';

export const FixedMenuButton = ({ onClick }) => {
  return (
    <Button
      type="ghost"
      className={styles.FixedMenuButton}
      icon={<MenuFoldOutlined />}
      onClick={onClick}
    >
      {labels.label_max_min}
    </Button>
  );
};
